import find from 'lodash/find'
import matchPath from '../services/resolver/match-path'
import headerRoutes from '../routes/header-routes'
import mainRoutes from '../routes/routes'
import footerRoutes from '../routes/footer-routes'

type PreloadFn = (location?: unknown) => Promise<unknown>

type RouteLike = {
  path?: string
  component?: {
    preload?: PreloadFn
  }
}

export type HydrateLocation = {
  pathname: string
  query?: unknown
}

/**
 * First-match per set, same rules as Router.jsx: exact pathname, '*', then matchPath.
 */
export function collectRoutePreloads (
  routeSets: RouteLike[][],
  pathname: string,
): PreloadFn[] {
  return routeSets.reduce<PreloadFn[]>((preloads, routes) => {
    const route = find(routes, ({ path }) => {
      if (!path) return false
      if (path === pathname || path === '*') return true
      return matchPath({ path, pathname })
    }) as RouteLike | undefined
    const preload = route && route.component && route.component.preload
    if (preload) {
      preloads.push(preload)
    }
    return preloads
  }, [])
}

export async function preloadHydrateRouteModules (location: HydrateLocation) {
  const { pathname } = location
  const sets = [
    headerRoutes as RouteLike[],
    mainRoutes as RouteLike[],
    footerRoutes as RouteLike[],
  ]
  await Promise.all(
    collectRoutePreloads(sets, pathname).map((fn) => fn(location)),
  )
}
